import React, { ReactElement } from 'react';
import {
  Platform,
  StyleSheet,
  TouchableHighlight,
  TouchableNativeFeedback,
  View,
} from 'react-native';
import ReactNativeHapticFeedback from 'react-native-haptic-feedback';

import Colors from '../theming/Colors';
import { colorForScheme } from '../theming/Theming';
import KitIcon from './KitIcon';

//******************************************************************************
// Types
//******************************************************************************
interface Props {
  icon?: string;
  onPress?: any;
  disabled?: boolean;
  children?: React.ReactNode;
  customStyle?: any;
}

const onButtonPress = () => {
  ReactNativeHapticFeedback.trigger('impactLight', {
    enableVibrateFallback: true,
    ignoreAndroidSystemSettings: false,
  });
};

//******************************************************************************
// Component
//******************************************************************************

export default function KitFloatingButton(props: Props): ReactElement {
  return (
    <Wrapper {...props}>
      <View
        style={[
          styles.buttonWrapper,
          props.customStyle,
          props.disabled && styles.disabled,
        ]}
      >
        {/* @ts-ignore */}
        <KitIcon name={props.icon} color={Colors.N0} size={20} />
      </View>
    </Wrapper>
  );
}

function Wrapper({ children, disabled = false, onPress = () => null }: Props) {
  if (Platform.OS === 'android') {
    return (
      <View style={styles.androidWrapper}>
        <TouchableNativeFeedback
          disabled={disabled}
          onPress={() => {
            onButtonPress();
            onPress();
          }}
          useForeground={true}
        >
          {children}
        </TouchableNativeFeedback>
      </View>
    );
  } else {
    return (
      <TouchableHighlight
        style={styles.iosWrapper}
        disabled={disabled}
        onPress={() => {
          onButtonPress();
          onPress();
        }}
        underlayColor='#000'
      >
        {children}
      </TouchableHighlight>
    );
  }
}

//******************************************************************************
// Styles
//******************************************************************************
const styles = StyleSheet.create({
  androidWrapper: {
    borderRadius: 28,
    overflow: 'hidden',
    elevation: 3,
  },
  iosWrapper: {
    borderRadius: 28,
    height: 56,
    width: 56,
  },
  buttonWrapper: {
    alignItems: 'center',
    backgroundColor: colorForScheme({ default: Colors.brand }),
    borderRadius: 28,
    height: 56,
    width: 56,
    justifyContent: 'center',
    ...Platform.select({
      ios: {
        shadowColor: 'rgba(0, 0, 0, 0.35)',
        shadowOffset: { width: 0, height: 5 },
        shadowOpacity: 1,
        shadowRadius: 5,
      },
    }),
  },
  disabled: {
    opacity: 0.8,
  },
});
